import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sort-down",
  "use": "icon-sort-down-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-sort-down\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M0 0h16v16H0z\" />\n        <path d=\"M8.787 14.84h1.243l5.233-5.231-2.254-.009-4.222 4.114v1.127zm-.053-2.12 1.6-1.6V1.2h-1.6v11.52zM.8 14.8h6.4v-1.6H.8v1.6zm.8-4h5.6V9.2H1.6v1.6zm.8-4h4.8V5.2H2.4v1.6zm.8-4h4V1.2h-4v1.6z\" fill=\"#000018\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol